<template>
  <div class="gallery">
    <div class="container">
      <div class="heading text-center with-border mb-5" data-aos="fade-down">
        <h2 class="title text-uppercase text-teal-dark">Gallery</h2>
      </div>
      <!-- <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 mb-4">
          <iframe width="100%" height="285" src="https://www.youtube.com/embed/A89rarMZJac" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div> -->
      <div class="row justify-content-center">
        <div
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="flex-wrap row d-flex justify-content-center">
            <div
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}&w-600`">
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center d-md-flex d-none"> -->
        <!-- <div class="col-md-12 col-lg-10 col-xl-8"> -->
          <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="left control" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="right control" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid"/>
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by <a :href="preview.copyright.link || null">{{ preview.copyright.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      slickOpt: {
        slideToShow: 1
      },
      gallery: [
        {
          className: 'col-12',
          items: [
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image19.jpeg?updatedAt=1632831513948',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image16.jpeg?updatedAt=1632831510775',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image11.jpeg?updatedAt=1632831506028',
              transition: "fade-down-right",
              class: "col-12 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/1632825431567_image1.jpeg?updatedAt=1632831494119',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-10 order-md-12",
            },

            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image21.jpeg?updatedAt=1632831516048',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-12 order-md-0",
            },


            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image20.jpeg?updatedAt=1632831515053',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-2 order-md-0",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image18.jpeg?updatedAt=1632831512717',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-2 order-md-2",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image17.jpeg?updatedAt=1632831511589',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-2 order-md-2",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image15.jpeg?updatedAt=1632831509710',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-2",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image14.jpeg?updatedAt=1632831508747',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-2",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image13.jpeg?updatedAt=1632831507790',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-2 order-md-2",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image12.jpeg?updatedAt=1632831506911',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image10.jpeg?updatedAt=1632831505115',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image8.jpeg?updatedAt=1632831503199',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image6.jpeg?updatedAt=1632831501332',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image5.jpeg?updatedAt=1632831500383',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image4.jpeg?updatedAt=1632831499461',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image3.jpeg?updatedAt=1632831498360',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image1.jpeg?updatedAt=1632832965684',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/image0.jpeg?updatedAt=1632833004914',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-4",
            },
            {
              full: 'https://ik.imagekit.io/ceremonyku/dekbeg-lilly/1632825452357_image1.jpeg?updatedAt=1632831494548',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-3 order-md-12",
            },
          ],
        },
      ],
      preview: null
    };
  },
  mounted() {
    document.addEventListener("keydown", e => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    }
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach(items => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map(item => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    }
  },
  watch: {
    preview() {
      if(this.preview === null) {
        document.querySelector('body').style.overflowY = null;
      } else {
        document.querySelector('body').style.overflowY = 'hidden';
      }
    }
  }
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.w-100i {
  width: 100% !important;
  max-width: 100% !important;
  flex: 0 0 100% !important;
}
</style>
